import { createEditor } from 'com/Editor';
import { apiAddTest, apiGetTest, apiUpdateTest } from 'core/api';
import { TTestUpdate } from 'shared/types/domain';

import Form from './Form';

const editor = createEditor<null, TTest, TTestUpdate>({
  mode: 'withoutContainer',
  transform,
  Form,
  getParentUid: () => '%fakeParentId%',
  onValidate: validate,
  genNewEntity: (): TTestUpdate => ({
    name: '',
  }),
  // oxlint-disable-next-line typescript-eslint/require-await
  apiGetContainer: async () => null,
  apiGetEntity: apiGetTest,
  apiUpdateEntity: apiUpdateTest,
  apiAddEntity: (_containerId, test) => apiAddTest(test),
});

function validate(test: TTestUpdate | TTest) {
  if (!test.name) {
    return { isEmpty: true, error: null };
  }

  return { isEmpty: false, error: null };
}

function transform(
  test: TTest | TTestUpdate,
  field: string,
  _subField: string | undefined,
  value: string
): TTestUpdate {
  return { ...test, [field as keyof TTest]: value ? value : null };
}

export const TestEditorProvider = editor.EditorProvider;
export const useTestEditor = function useTestEditor() {
  const { createEntity, editEntity } = editor.useEditor();
  return {
    createTest: () => createEntity('%fakeParentId%'),
    editTest: editEntity,
  };
};
